export default "__VITE_ASSET__b739e56a__"